export default {"src":"/_next/static/media/tzc.b630ecf2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};